// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PIh3","colMin":"styles_colMin__3k8l0"};